<template>
  <div class="search-form">
    <b-row>
      <b-col>
        <span style="font-size: 18px; color: #2B3447;font-weight: 600">{{
          $l('table_label_calculation') || '订单交付测算'
        }}</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      form: { ...initForm },
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
